import React from "react";

import { useI18n } from "@/context";

import { ReportsFilters, ReportsTable, SaleDetailsModal } from "./components";
import { useReports } from "./reports.hooks";

export const ReportsPage: React.FC = () => {
  const { t } = useI18n();
  const {
    paginatedSales,
    currentPage,
    totalPages,
    totalItems,
    itemsPerPage,
    filtersForm,
    handleApplyFilters,
    handleClearFilters,
    handlePageChange,
    statusOptions,
    partnerOptions,
    selectedSale,
    isDetailsModalOpen,
    handleOpenDetails,
    handleCloseDetails,
  } = useReports();

  return (
    <div className="flex flex-col w-full h-full space-y-6 p-4">
      <div className="flex flex-col w-full px-2">
        <h1 className="text-3xl font-bold tracking-tight text-foreground mb-3">
          {t("reports.title")}
        </h1>
        <p className="text-sm text-muted-foreground leading-relaxed">
          {t("reports.description")}
        </p>
      </div>

      <ReportsFilters
        form={filtersForm}
        onApplyFilters={handleApplyFilters}
        onClearFilters={handleClearFilters}
        statusOptions={statusOptions}
        partnerOptions={partnerOptions}
      />

      <ReportsTable
        sales={paginatedSales}
        currentPage={currentPage}
        totalPages={totalPages}
        itemsPerPage={itemsPerPage}
        totalItems={totalItems}
        onPageChange={handlePageChange}
        onOpenDetails={handleOpenDetails}
      />

      <SaleDetailsModal
        sale={selectedSale}
        isOpen={isDetailsModalOpen}
        onClose={handleCloseDetails}
      />
    </div>
  );
};

